import ButtonPrimaryLarge from '../../components/common/ButtonPrimary/ButtonPrimaryLarge';
import './LinkExperied.scss';
import { useTranslation } from 'react-i18next';

const LinkExperied = () => {
  const { t } = useTranslation();
  return (
    <div className="flex py-40 px-80 flex-col items-center self-stretch gap-24">
      <div className="flex py-24 justify-center items-center self-stretch">
        <div
          className="flex items-center rounded-[100px]"
          style={{
            width: '124px',
            height: '124px',
            backgroundImage: "url('/assets/icons/link.png')",
          }}
        ></div>
      </div>
      <h2>{t('Link expired')}</h2>
      <span className="text-body-medium text-center">
        <p>
          {t('It looks like you accessed an expired or non-existent link.')}
        </p>
        <p>
          {t(
            "But don't worry, we're always ready to help you get back on track!"
          )}
        </p>
      </span>
      <ButtonPrimaryLarge title={t('New link')} onClick={''} />
      <span className="text-body-medium">
        {t(
          'Please check your email for a new link. Contact us if you need further assistance.'
        )}
      </span>
    </div>
  );
};

export default LinkExperied;
